var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2279 11.9999L21.8499 10.0799C22.3149 8.64286 21.6679 7.07986 20.3229 6.39286L18.5259 5.47486L17.6079 3.67786C16.9209 2.33286 15.3579 1.68486 13.9209 2.15086L11.9999 2.77186L10.0799 2.14986C8.64286 1.68486 7.07986 2.33186 6.39286 3.67686L5.47386 5.47386L3.67686 6.39286C2.33186 7.07986 1.68486 8.64286 2.14986 10.0799L2.77186 11.9999L2.14986 13.9199C1.68486 15.3569 2.33186 16.9199 3.67686 17.6069L5.47386 18.5249L6.39186 20.3219C7.07886 21.6669 8.64186 22.3149 10.0789 21.8489L11.9999 21.2279L13.9199 21.8499C15.3569 22.3149 16.9199 21.6679 17.6069 20.3229L18.5249 18.5259L20.3219 17.6079C21.6669 16.9209 22.3149 15.3579 21.8489 13.9209L21.2279 11.9999ZM10.2929 15.7069L7.99986 13.4139C7.60986 13.0239 7.60986 12.3899 7.99986 11.9999C8.38986 11.6099 9.02386 11.6099 9.41386 11.9999L10.9999 13.5859L15.5859 8.99986C15.9759 8.60986 16.6099 8.60986 16.9999 8.99986C17.3899 9.38986 17.3899 10.0239 16.9999 10.4139L11.7069 15.7069C11.3169 16.0969 10.6829 16.0969 10.2929 15.7069Z",
    fill: "#FF9757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedTick);
export default __webpack_public_path__ + "static/media/verified-tick.61b8b2e63adcb4b62f26a72eaf1bdac8.svg";
export { ForwardRef as ReactComponent };